import defaultDayjs, { Dayjs } from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import duration from "dayjs/plugin/duration";
import updateLocale from "dayjs/plugin/updateLocale";
import "dayjs/locale/ru";
import "dayjs/locale/en";
import "dayjs/locale/fr";
const dayjs = defaultDayjs;
dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(updateLocale);
dayjs.locale("ru");
dayjs.updateLocale("en", {
  // Sunday = 0, Monday = 1.
  weekStart: 1
});
export {
  Dayjs,
  dayjs
};
